import ErrorIcon from '@mui/icons-material/Error';
import Locale from '../Locale';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import styles from './BaseErrorOverlay.styles';

const useStyles = makeStyles()(styles);

const BaseErrorOverlay = props => {
    const { classes } = useStyles();
    const message = props.error.message || props.error;
    const path = typeof message === 'string' ? message : props.defaultLabel;

    return (
        <div className={classes.content}>
            <ErrorIcon />
            <p className={classes.message}>
                <Locale path={path} />
            </p>
        </div>
    );
};

BaseErrorOverlay.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.string,
    ]),
    defaultLabel: PropTypes.string,
};

BaseErrorOverlay.defaultProps = {
    defaultLabel: 'common.errors.400',
};

export default BaseErrorOverlay;
